import { QuestionOutlined } from '@ant-design/icons';

const icons = { QuestionOutlined };

const support = {
  id: 'support',
  title: 'Support',
  type: 'group',
  children: [
    {
      id: 'documentation',
      title: 'Zenigma Labs',
      type: 'item',
      url: 'https://zenigmalabs.com/',
      icon: icons.QuestionOutlined,
      external: true,
      target: true
    }
  ]
};

export default support;
